"use client";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Button, Card, Typography } from "@mui/material";

type Props = {
    email: string;
    isAutoConfirmed?: boolean;
    onReturnHome: () => void;
};

export const BookingSuccess = ({ email, isAutoConfirmed = false, onReturnHome }: Props) => {
    return (
        <Box
            component={Card}
            sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 2,
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                border: "none",
                textAlign: "center",
                bgcolor: "white",
            }}
        >
            <Box sx={{ mb: 4 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "primary.main", mb: 2 }} />
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                    {isAutoConfirmed
                        ? "Reservation Confirmed! 🎉"
                        : "Reservation Request Received 🙌"}
                </Typography>
                <Typography variant="h6" sx={{ color: "text.secondary", fontWeight: 500 }}>
                    {isAutoConfirmed ? "You are all set!" : "We've got your request!"}
                </Typography>
            </Box>

            <Box
                sx={{
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "rgba(16, 185, 129, 0.05)",
                    border: "1px solid rgba(16, 185, 129, 0.1)",
                    mb: 4,
                    textAlign: "left",
                }}
            >
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {isAutoConfirmed ? (
                        <>
                            We&apos;ve sent a confirmation email to <b>{email}</b>. Can&apos;t wait
                            to see you!
                        </>
                    ) : (
                        <>
                            We&apos;ll email <b>{email}</b> once the restaurant confirms your
                            booking.
                        </>
                    )}
                </Typography>
                {!isAutoConfirmed && (
                    <Typography variant="body1">
                        Thanks for your patience — we look forward to seeing you soon!
                    </Typography>
                )}
            </Box>

            <Button
                variant="outlined"
                onClick={onReturnHome}
                sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    px: 4,
                }}
            >
                Return to Home
            </Button>
        </Box>
    );
};
